import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import { Fragment, useEffect, useState } from 'react';
import { useStateContext } from '../context/ContextProvider';
import axiosClient from '../axios-client';

// Roles that MUST select a business before accessing workspace pages
const CLIENT_ROLES = ['AdminClient', 'ManagerClient', 'RespoSuiviClient', 'StockManagerClient'];

// Routes that don't require a business to be selected (e.g., subscription page, profile)
const BUSINESS_EXEMPT_PATHS = [
  '/select-business',
  '/mes-businesses',
  '/ajouter-business',
  '/modifier-business',
  '/business-detail',
  '/profil',
  '/modifier-profil',
  '/securite-de-compte',
  '/PlansAbonnement',
  '/paiement',
  '/ticket',
  '/tickets',
  '/my-tickets',
  '/unauthorized',
];

const RequireAuth = ({ element, allowedRoles }) => {
  const { user, token, currentBusiness } = useStateContext();
  const isAuthenticated = !!token;
  const navigate = useNavigate();
  const location = useLocation();

  // ── Role-based access check ───────────────────────────────────────────────
  useEffect(() => {
    if (!allowedRoles) return;
    axiosClient.get('auth/user/')
      .then((response) => {
        if (!allowedRoles.includes(response.data.role)) {
          return navigate('/unauthorized');
        }
      })
      .catch((error) => {
        // console.log(error);
      });
  }, [allowedRoles]);

  // ── Not authenticated → login ─────────────────────────────────────────────
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // ── Business selection enforcement for client roles ───────────────────────
  const isClientRole = CLIENT_ROLES.includes(user?.role);
  const currentPath = location.pathname;
  const isExemptPath = BUSINESS_EXEMPT_PATHS.some(
    (p) => currentPath === p || currentPath.startsWith(p + '/')
  );

  if (isClientRole && !currentBusiness && !isExemptPath) {
    return <Navigate to="/select-business" replace />;
  }

  return (
    <Fragment>
      {element}
    </Fragment>
  );
};

export default RequireAuth;